import React from 'react'
import PropTypes from 'prop-types'

import appIcon from '../../assets/images/app-icon.jpg'

export const Apps = ({ appsData, defaultApp, setApp, isDefaultOrg, setDefaultApp }) => {
  const isFavorite = (data) => {
    const res = isDefaultOrg?.favouriteOrgs?.filter((f) => f.orgId === data.orgId) || []
    return res.length > 0
  }

  return (
    <div className="trtui-col-xxl-3 trtui-col-sm-6 trtui-project-card">
      <div className="trtui-card trtui-card-height-100">
        <div className="trtui-card-body">
          <div className="trtui-d-flex trtui-flex-column trtui-h-100">
            <div className="trtui-d-flex">
              <div className="trtui-flex-grow-1">
                <p className="trtui-text-muted trtui-mb-4">
                  {appsData.orgCity}, {appsData.orgProvince}
                </p>
              </div>
              <div className="trtui-flex-shrink-0">
                <div className="trtui-d-flex trtui-gap-1 trtui-align-items-center">
                  <button
                    type="button"
                    className="trtui-btn trtui-avatar-xs trtui-mt-n1 trtui-p-0 trtui-favourite-btn"
                    onClick={() => (isFavorite(appsData) ? null : setDefaultApp(appsData, true))}
                    title={`${isFavorite(appsData) ? '' : 'Add To Favorites'}`}
                  >
                    <span className="trtui-avatar-title trtui-bg-transparent trtui-fs-15">
                      <i
                        className={`${isFavorite(appsData) ? 'ri-heart-add-fill trtui-text-danger' : 'ri-heart-add-line trtui-text-info'}`}
                      ></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="trtui-d-flex trtui-mb-2">
              <div className="trtui-flex-shrink-0 trtui-me-3">
                <div className="trtui-avatar-sm">
                  <span className="trtui-avatar-title trtui-bg-warning-subtle trtui-rounded trtui-p-2">
                    <img src={appIcon} alt className="trtui-img-fluid trtui-p-1" />
                  </span>
                </div>
              </div>
              <div className="trtui-flex-grow-1">
                <h5 className="trtui-mb-1 trtui-fs-15">
                  <a href="#!" className="trtui-text-body">
                    {appsData.orgName}
                  </a>
                </h5>
                <p className="trtui-text-muted trtui-text-truncate-two-lines trtui-mb-3">
                  {appsData.orgHeader}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="trtui-card-footer trtui-bg-transparent trtui-border-top-dashed trtui-py-2">
          <div className="trtui-d-flex trtui-align-items-center" key={isDefaultOrg?.orgId}>
            <div className="trtui-flex-grow-1">
              <button
                className="trtui-btn trtui-btn-sm trtui-btn-success"
                type="button"
                disabled={isDefaultOrg?.orgId === appsData.orgId}
                onClick={() => setDefaultApp(appsData, appsData.orgType)}
              >
                Set As Default
              </button>
            </div>
            <div className="trtui-flex-shrink-0">
              <div className="trtui-text-muted">
                <button
                  className="trtui-btn trtui-btn-sm trtui-btn-primary"
                  type="button"
                  disabled={
                    (defaultApp === null || defaultApp.orgId !== appsData.orgId ? false : true) ||
                    isDefaultOrg?.orgId === appsData.orgId
                  }
                  onClick={() => setApp(appsData, appsData.orgType)}
                >
                  Select Org
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Apps.propTypes = {
  appsData: PropTypes.object,
  defaultApp: PropTypes.object,
  setApp: PropTypes.func,
  isLocalEnvironment: PropTypes.string,
  authDetails: PropTypes.object,
  isDefaultOrg: PropTypes.object,
  setIsDefaultOrg: PropTypes.func,
  setDefaultApp: PropTypes.func,
}
